<!--
<div class="base" (click)="baseOnClick()">
    <div class="contenedor" id="contenedor">
        <div class="contenido">
            <input autocomplete="off" role="combobox" list="" id="cbInput" (focus)="cbInputOnFocus()"
                (input)="cbInputOnInput()" (keydown)="cbInputOnKeydown($event)" (click)="inputOnClick()"
                placeholder={{cbPlaceholder}}>
            <div class="combo scroll-hidex-showy">
                <datalist id="cbDatalist">
                    <option *ngFor="let opc of cbOpciones;index as i" [ngValue]="opc" (click)="emitirRespuesta(opc)"
                        class="combo-button">
                        {{ opc }}
                    </option>
                </datalist>
            </div>
        </div>
    </div>
</div>
-->

<div class="base" (click)="baseOnClick()">
    <div class="contenedor" id="contenedor">
        <div class="contenido">
            <div class="divdatepick">
                <div class="predetalle">
                    <div class="divnombremes" id="txtMes" (click)="abrirCombo('txtMes')">
                        <div class="txtmes">{{fNombreMes}}</div>
                        <div class="txtcaron">v</div>
                    </div>
                    <div class="divanio" id="txtAnio" (click)="abrirCombo('txtAnio')">
                        <!--<div class="txtcircumflex">^</div>-->
                        <div class="txtanio">{{fAnio}}</div>
                        <div class="txtcaron">v</div>
                    </div>
                </div>
                <div class="headerdatepick">
                    <div class="divcabeceracampo camponombredia">
                        <div class="txtnombredia">L</div>
                    </div>
                    <div class="divcabeceracampo camponombredia">
                        <div class="txtnombredia">M</div>
                    </div>
                    <div class="divcabeceracampo camponombredia">
                        <div class="txtnombredia">M</div>
                    </div>
                    <div class="divcabeceracampo camponombredia">
                        <div class="txtnombredia">J</div>
                    </div>
                    <div class="divcabeceracampo camponombredia">
                        <div class="txtnombredia">V</div>
                    </div>
                    <div class="divcabeceracampo camponombredia">
                        <div class="txtnombredia">S</div>
                    </div>
                    <div class="divcabeceracampo camponombredia">
                        <div class="txtnombredia">D</div>
                    </div>
                </div>
                <div class="cuerpodatepick">
                    <div class="detdatepick">
                        <div class="divcoldia">
                            <ul>
                                <li *ngFor="let d of fLunesArr;index as i">
                                    <div class="divnumcampo">
                                        <div [class]="asignaClase(i, d)" (click)="emitirRespuesta(i,d)">
                                            {{d}}<br>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="detdatepick">
                        <div class="divcoldia">
                            <ul>
                                <li *ngFor="let d of fMartesArr;index as i">
                                    <div class="divnumcampo">
                                        <div [class]="asignaClase(i, d)" (click)="emitirRespuesta(i,d)">
                                            {{d}}<br>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="detdatepick">
                        <div class="divcoldia">
                            <ul>
                                <li *ngFor="let d of fMiercolesArr;index as i">
                                    <div class="divnumcampo">
                                        <div [class]="asignaClase(i, d)" (click)="emitirRespuesta(i,d)">
                                            {{d}}<br>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="detdatepick">
                        <div class="divcoldia">
                            <ul>
                                <li *ngFor="let d of fJuevesArr;index as i">
                                    <div class="divnumcampo">
                                        <div [class]="asignaClase(i, d)" (click)="emitirRespuesta(i,d)">
                                            {{d}}<br>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="detdatepick">
                        <div class="divcoldia">
                            <ul>
                                <li *ngFor="let d of fViernesArr;index as i">
                                    <div class="divnumcampo">
                                        <div [class]="asignaClase(i, d)" (click)="emitirRespuesta(i,d)">
                                            {{d}}<br>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="detdatepick">
                        <div class="divcoldia">
                            <ul>
                                <li *ngFor="let d of fSabadoArr;index as i">
                                    <div class="divnumcampo">
                                        <div [class]="asignaClase(i, d)" (click)="emitirRespuesta(i,d)">
                                            {{d}}<br>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="detdatepick">
                        <div class="divcoldia">
                            <ul>
                                <li *ngFor="let d of fDomingoArr;index as i">
                                    <div class="divnumcampo">
                                        <div [class]="asignaClase(i, d)" (click)="emitirRespuesta(i,d)">
                                            {{d}}<br>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="predetalle">
                    <div class="txtcerrar">Cerrar</div>
                </div>
            </div>
        </div>
    </div>
</div>